var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"shrink",attrs:{"alt":"loader","src":"/img/illustrations/loader.svg","width":"100%","height":"100%","transition":"fade-transition"}})}
var staticRenderFns = []

export { render, staticRenderFns }